import React, { useState } from "react";
import "../../css/entry.css";
import "../../css/reports.css";
import { Box, Card, CardContent } from "@mui/material";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";
import EditPO from "./EditPO";
import EditMaterialData from "./EditMaterialData";
import EditBill from "./EditBill";
import EditBillPassing from "./EditBillPassing";
import EditCRN from "./EditCRN";
import EditPayment from "./EditPayment";

function EditData() {
  const [component, setComponent] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");

  const menuoptions1 = [
    { value: "1", label: "Update PO Data" },
     { value: "2", label: "Update Received Material Data" },
     { value: "4", label: "Update Bill Entry Data" },
    // { value: "5", label: "Update Bill Passing/Funding Data" },
    // { value: "6", label: "Update CRN Entry" },
    // { value: "7", label: "Update Payment Entry" },
  ];

  const handleOptionChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    // Load component based on selection
    let loadedComponent = null;
    
    switch (value) {
      case "1":
        loadedComponent = <EditPO />;
        break;
      case "2":
        loadedComponent = <EditMaterialData />;
        break;
      case "4":
        loadedComponent = <EditBill />;
        break;
      case "5":
        loadedComponent = <EditBillPassing />;
        break;
      case "6":
        loadedComponent = <EditCRN />;
        break;
      case "7":
        loadedComponent = <EditPayment />;
        break;
      default:
        loadedComponent = null;
    }
    setComponent(loadedComponent);
  };

  return (
    <>
      <Card className="Formcard">
        <div className="input-groupHeading">
          Mechanical Workshop NER, Gorakhpur
        </div>
        <CardContent>
          <div className="row">
            <div className="container">
              <div className="input-group">
                <CustomDropdownMenu
                  options={menuoptions1}
                  selectedOption={selectedOption}
                  handleOptionChange={handleOptionChange}
                  menulabel="Select which Data you want to Update"
                />
              </div>
            </div>
          </div>
          {component && (
            <div style={{ padding: "10px" }}>
              {component}
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
}

export default EditData;
